var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup497(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 141,
    viewBox: "0 0 165 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.5102 134.784C104.331 134.784 122.02 117.236 122.02 95.5902C122.02 73.9441 104.331 56.3965 82.5102 56.3965C60.6893 56.3965 43 73.9441 43 95.5902C43 117.236 60.6893 134.784 82.5102 134.784Z",
    fill: "url(#paint0_radial_778_953)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M99.6006 141H164.138L128.333 79.5C130.112 84.541 131.086 89.9601 131.086 95.5892C131.107 116.32 118.022 134.006 99.6006 141Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M82.0701 46.9443C96.9552 46.9443 110.295 53.5396 119.294 63.9366L82.0701 0L44.8467 63.9576C53.8455 53.5606 67.185 46.9443 82.0701 46.9443Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.0522 95.5892C33.0522 89.9391 34.0262 84.541 35.8048 79.5L0 141H64.5375C46.1376 134.006 33.0522 116.32 33.0522 95.5892Z",
    fill: "#353535"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_778_953",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.899 84.0075) scale(39.0507 38.7031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1587,
    stopColor: "#F8E6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#E4A7A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6179,
    stopColor: "#C64346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6445,
    stopColor: "#C3393C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup497);
export default __webpack_public_path__ + "static/media/Group 497.f3488cbfb7340059779768c597ba0d4d.svg";
export { ForwardRef as ReactComponent };